import { z } from 'zod';

import {
  MarketKycDocvSchema,
  MarketKycDocvStatusSchema,
  MarketTradingStatusSchema,
} from '~/domains/market/domains/kyc/services/interfaces/kyc.types';

export const MarketStateConfigSchema = z.object({
  disallowed: z.array(z.string()),
  state: z.string(),
});

export const FeeFormulaTypeSchema = z.literal('symmetric_price_uncertainty');

export const FlatFeeInfoSchema = z.object({
  type: z.literal('flat'),
  per_contract: z.number(),
});

export const PercentageFeeInfoSchema = z.object({
  type: z.literal('percentage'),
  rate: z.number(),
});

export const FormulaFeeInfoSchema = z.object({
  type: z.literal('formula'),
  formula_type: FeeFormulaTypeSchema,
  theta: z.number(),
});

export const FeeInfoSchema = z.discriminatedUnion('type', [
  FlatFeeInfoSchema,
  PercentageFeeInfoSchema,
  FormulaFeeInfoSchema,
]);

export const MarketAccountResponseSchema = z.object({
  trading_status: MarketTradingStatusSchema.optional(),
  docv: MarketKycDocvSchema.optional(),
  kyc_docv_status: MarketKycDocvStatusSchema.optional(),
  kyc_failure_reason: z.string().optional(),
  max_bet: z.number(),
  fee: FeeInfoSchema.optional(),
  state_config: MarketStateConfigSchema,
});

export const normalizeMarketAccountResponse = (
  account: MarketAccountResponse
): MarketAccountResponse => ({
  ...account,
  trading_status: MarketTradingStatusSchema.optional().parse(account.trading_status),
  kyc_docv_status: MarketKycDocvStatusSchema.optional().parse(account.kyc_docv_status),
});

export type MarketStateConfig = z.infer<typeof MarketStateConfigSchema>;
export type FeeFormulaType = z.infer<typeof FeeFormulaTypeSchema>;
export type FlatFeeInfo = z.infer<typeof FlatFeeInfoSchema>;
export type PercentageFeeInfo = z.infer<typeof PercentageFeeInfoSchema>;
export type FormulaFeeInfo = z.infer<typeof FormulaFeeInfoSchema>;
export type FeeInfo = z.infer<typeof FeeInfoSchema>;
export type MarketAccountResponse = z.infer<typeof MarketAccountResponseSchema>;
